import { ShareClassType } from '../../../__generated__/graphql';
/**
 * Helpers
 */
var ShareClassTypeDisplayName;
(function (ShareClassTypeDisplayName) {
    ShareClassTypeDisplayName["COMMON"] = "Common";
    ShareClassTypeDisplayName["PREFERRED"] = "Preferred";
})(ShareClassTypeDisplayName || (ShareClassTypeDisplayName = {}));
export var typeOptions = Object.keys(ShareClassType).map(function (k) { return ({
    id: ShareClassType[k],
    name: ShareClassTypeDisplayName[k],
}); });
//# sourceMappingURL=helpers.js.map